var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup9722(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 5.99976C0.895512 5.99976 -0.000488281 6.89576 -0.000488281 7.99976C-0.000488281 9.10376 0.895512 9.99976 1.99951 9.99976C3.10351 9.99976 3.99951 9.10376 3.99951 7.99976C3.99951 6.89576 3.10351 5.99976 1.99951 5.99976Z",
    fill: "#1B1A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 4C3.10351 4 3.99951 3.104 3.99951 2C3.99951 0.896 3.10351 0 1.99951 0C0.895512 0 -0.000488281 0.896 -0.000488281 2C-0.000488281 3.104 0.895512 4 1.99951 4Z",
    fill: "#1B1A1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 12C0.895512 12 -0.000488281 12.896 -0.000488281 14C-0.000488281 15.104 0.895512 16 1.99951 16C3.10351 16 3.99951 15.104 3.99951 14C3.99951 12.896 3.10351 12 1.99951 12Z",
    fill: "#1B1A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9722);
export default __webpack_public_path__ + "static/media/Group 9722.2d7642af52b86f8bd79217d3f64ebd98.svg";
export { ForwardRef as ReactComponent };